/**
 * Weighted checksum for 7-digit QGSC card numbers.
 * Weights [29,23,19,17,13,11] on first 6 digits; sum % 10 must equal check digit.
 */
export const checksumQGSC7Digit = (cardNumber: string): boolean => {
    const weights = [29, 23, 19, 17, 13, 11];
    const digits = cardNumber.split('').map(Number);
    let sum = 0;
    for (let i = 0; i < 6; i++) {
        sum += weights[i] * digits[i];
    }
    return sum % 10 === digits[6];
};

/**
 * Weighted checksum for 8-digit QGSC card numbers.
 * Weights [29,23,19,17,13,11,9] on first 7 digits; sum % 10 must equal check digit.
 */
export const checksumQGSC8Digit = (cardNumber: string): boolean => {
    const weights = [29, 23, 19, 17, 13, 11, 9];
    const digits = cardNumber.split('').map(Number);
    let sum = 0;
    for (let i = 0; i < 7; i++) {
        sum += weights[i] * digits[i];
    }
    return sum % 10 === digits[7];
};
